<template>
  <v-btn
    v-if="showdetail"
    fab
    width="27"
    height="27"
    color="primary"
    elevation="0"
    class="btn_tippy vuetify--sacnite"
    :class="clase + (loading ? ' loading' : '')"
    :loading="loading"
    :title="$t('view.commons.detail')"
    @click="detail(item)">
    <em class="fas fa-search" />
  </v-btn>
</template>
<script>
export default {
  name: "ButtonDetail"
  , props: {
    item: {
      default: null
      , type: Object
    }
    , showdetail: {
      default: true
      , type: Boolean
    }
    , loading: {
      default: false
      , type: Boolean
    }
    , clase: {
      default: null
      , type: String
    }
  }
  , methods: {
    detail(item) {
      this.$emit("detail", item);
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/datatable/ButtonDetail.vue